"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _grommet = require("grommet");

var _Header = _interopRequireDefault(require("./components/Header"));

var _Subscribe = _interopRequireDefault(require("./components/Subscribe"));

var _Events = _interopRequireDefault(require("./components/Events"));

var _Stats = _interopRequireDefault(require("./components/Stats"));

var _Photos = _interopRequireDefault(require("./components/Photos"));

var _Social = _interopRequireDefault(require("./components/Social"));

var _Officers = _interopRequireDefault(require("./components/Officers"));

var _Memories = _interopRequireDefault(require("./components/Memories"));

var _Reasons = _interopRequireDefault(require("./components/Reasons"));

var _ErrorPopup = _interopRequireDefault(require("./components/ErrorPopup"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ClubPage = /*#__PURE__*/function (_React$Component) {
  _inherits(ClubPage, _React$Component);

  var _super = _createSuper(ClubPage);

  function ClubPage(props) {
    var _this;

    _classCallCheck(this, ClubPage);

    _this = _super.call(this, props);
    _this.state = {
      errorPopup: false,
      media: []
    };
    _this.errorPopup = _this.errorPopup.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ClubPage, [{
    key: "errorPopup",
    value: function errorPopup() {
      if (this.state.errorPopup) {
        this.setState({
          errorPopup: false
        });
      } else {
        this.setState({
          errorPopup: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      console.log("RENDER"); // unselected

      if (this.props.size === "off") {
        return /*#__PURE__*/_react["default"].createElement("div", null);
      } // desktop
      else if (window.innerWidth >= 1150) {
          var width = 0;

          if (window.innerWidth > 1717) {
            width = 1283;
          } else if (window.innerWidth >= 1601 && window.innerWidth <= 1717) {
            width = window.innerWidth - 434;
          } else if (window.innerWidth >= 1268 && window.innerWidth <= 1600) {
            width = 1166;
          } else {
            width = window.innerWidth - 100;
          }

          return /*#__PURE__*/_react["default"].createElement(_grommet.Layer, {
            style: {
              background: "none"
            },
            onEsc: function onEsc() {
              return _this2.props.changeWindowSize("off", null, null);
            },
            onClickOutside: function onClickOutside() {
              return _this2.props.changeWindowSize("off", null, null);
            }
          }, /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
            background: "white",
            round: "25px",
            width: "".concat(width, "px"),
            height: "668px"
          }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
            adminState: this.props.adminState,
            reactToSubmission: this.props.reactToSubmission,
            changeEmailPopup: this.props.changeEmailPopup,
            token: this.props.token,
            info: this.props.info,
            color: "#1455A6",
            email: this.props.info.email,
            changeWindowSize: this.props.changeWindowSize,
            heartFn: this.props.heartFn
          }), /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
            direction: "row",
            style: {
              position: "absolute",
              left: "0px",
              right: "0px",
              bottom: "0px",
              top: "75px"
            }
          }, /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
            style: {
              position: "relative",
              width: "".concat((width - 15) * 0.4, "px"),
              height: "100%"
            }
          }, /*#__PURE__*/_react["default"].createElement(_Photos["default"], {
            info: this.props.info
          }), /*#__PURE__*/_react["default"].createElement(_Officers["default"], {
            color: this.props.color,
            officers: this.props.info.officers
          })), /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
            style: {
              position: "relative",
              width: "".concat((width - 15) * 0.3, "px"),
              height: "100%"
            }
          }, /*#__PURE__*/_react["default"].createElement(_Subscribe["default"], {
            email: this.props.email,
            token: this.props.token,
            clubUUID: this.props.info.uuid,
            mailingList: this.props.info.mailingList,
            editMailingList: this.props.editMailingList
          }), /*#__PURE__*/_react["default"].createElement(_Events["default"], {
            color: this.props.color,
            token: this.props.token,
            clubUUID: this.props.info.uuid,
            zoom: this.props.info.zoom,
            events: this.props.events,
            timezone: this.props.timezone,
            getClubEvents: this.props.getClubEvents,
            addToCal: this.props.addToCal,
            errorPopup: this.errorPopup,
            authenticator: this.props.authenticator,
            name: this.props.info.name,
            editMailingList: function editMailingList() {
              return _this2.props.editMailingList(true, _this2.props.info.uuid, _this2.props.email, function () {}, true);
            }
          }), /*#__PURE__*/_react["default"].createElement(_Stats["default"], {
            info: this.props.info
          })), /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
            style: {
              position: "relative",
              width: "".concat((width - 15) * 0.3, "px"),
              height: "100%"
            }
          }, /*#__PURE__*/_react["default"].createElement(_Social["default"], {
            info: this.props.info
          }), /*#__PURE__*/_react["default"].createElement(_Memories["default"], {
            question: this.props.info.askedanswered_question,
            clubName: this.props.info.name,
            mems: this.props.info.memories
          }), /*#__PURE__*/_react["default"].createElement(_Reasons["default"], {
            reasons: this.props.info.keyReasons,
            color: this.props.color
          })))), this.state.errorPopup ? /*#__PURE__*/_react["default"].createElement(_ErrorPopup["default"], {
            title: "No Meeting Link",
            message: "This club has not provided a meeting link for this event",
            closePopup: this.errorPopup
          }) : /*#__PURE__*/_react["default"].createElement("div", null));
        } // tablet
        else if (window.innerWidth >= 768 && window.innerWidth <= 1149) {
            return /*#__PURE__*/_react["default"].createElement(_grommet.Layer, {
              responsive: false,
              style: {
                background: "none"
              },
              onEsc: function onEsc() {
                return _this2.props.changeWindowSize("off", null, null);
              },
              onClickOutside: function onClickOutside() {
                return _this2.props.changeWindowSize("off", null, null);
              }
            }, /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              background: "white",
              round: "25px",
              width: "668px",
              height: "668px"
            }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
              adminState: this.props.adminState,
              reactToSubmission: this.props.reactToSubmission,
              changeEmailPopup: this.props.changeEmailPopup,
              token: this.props.token,
              info: this.props.info,
              color: "#1455A6",
              email: this.props.info.email,
              changeWindowSize: this.props.changeWindowSize,
              heartFn: this.props.heartFn
            }), /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              direction: "row",
              style: {
                position: "absolute",
                left: "0px",
                right: "0px",
                bottom: "0px",
                top: "75px"
              }
            }, /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              style: {
                borderRadius: '25px',
                position: "relative",
                width: "100%",
                height: "100%",
                overflowY: "scroll",
                overflowX: "hidden"
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                position: "absolute",
                top: "0px",
                left: "0px",
                width: "326.5px",
                height: "147px"
              }
            }, /*#__PURE__*/_react["default"].createElement(_Events["default"], {
              color: this.props.color,
              token: this.props.token,
              clubUUID: this.props.info.uuid,
              zoom: this.props.info.zoom,
              events: this.props.events,
              timezone: this.props.timezone,
              getClubEvents: this.props.getClubEvents,
              addToCal: this.props.addToCal,
              errorPopup: this.errorPopup,
              authenticator: this.props.authenticator,
              name: this.props.info.name,
              editMailingList: this.props.editMailingList
            })), /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                position: "absolute",
                top: "300px",
                left: "0px",
                width: "326.5px",
                height: "435px"
              }
            }, /*#__PURE__*/_react["default"].createElement(_Photos["default"], {
              info: this.props.info
            })), /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                position: "absolute",
                top: "738px",
                left: "0px",
                width: "326.5px",
                height: "121px"
              }
            }, /*#__PURE__*/_react["default"].createElement(_Social["default"], {
              info: this.props.info
            })), /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                position: "absolute",
                top: "615px",
                left: "326.5px",
                width: "326.5px",
                height: "243px",
                marginBottom: "15px"
              }
            }, /*#__PURE__*/_react["default"].createElement(_Memories["default"], {
              question: this.props.info.askedanswered_question,
              clubName: this.props.info.name,
              mems: this.props.info.memories
            })), /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                position: "absolute",
                top: "0px",
                left: "326.5px",
                width: "326.5px",
                height: "195px"
              }
            }, /*#__PURE__*/_react["default"].createElement(_Stats["default"], {
              info: this.props.info
            })), /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                position: "absolute",
                top: "192px",
                left: "326.5px",
                width: "326.5px",
                height: "162px"
              }
            }, /*#__PURE__*/_react["default"].createElement(_Officers["default"], {
              color: this.props.color,
              officers: this.props.info.officers
            })), /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                position: "absolute",
                top: "328px",
                left: "326.5px",
                width: "326.5px",
                height: "226px"
              }
            }, /*#__PURE__*/_react["default"].createElement(_Subscribe["default"], {
              email: this.props.email,
              token: this.props.token,
              clubUUID: this.props.info.uuid,
              mailingList: this.props.info.mailingList,
              editMailingList: this.props.editMailingList
            })), /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                position: "absolute",
                top: "409px",
                left: "326.5px",
                width: "326.5px",
                height: "211px"
              }
            }, /*#__PURE__*/_react["default"].createElement(_Reasons["default"], {
              reasons: this.props.info.keyReasons,
              color: this.props.color
            }))))), this.state.errorPopup ? /*#__PURE__*/_react["default"].createElement(_ErrorPopup["default"], {
              title: "No Meeting Link",
              message: "This club has not provided a meeting link for this event",
              closePopup: this.errorPopup,
              tablet: true
            }) : /*#__PURE__*/_react["default"].createElement("div", null));
          } // mobile
          else if (window.innerWidth >= 300 && window.innerWidth <= 767) {
              return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
                background: "white",
                style: {
                  position: "absolute",
                  left: "0px",
                  right: "0px",
                  top: "100px",
                  bottom: "0px",
                  padding: "0px 7.5px 32.5px 7.5px",
                  overflowX: "hidden"
                }
              }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
                adminState: this.props.adminState,
                reactToSubmission: this.props.reactToSubmission,
                changeEmailPopup: this.props.changeEmailPopup,
                token: this.props.token,
                info: this.props.info,
                color: "#1455A6",
                email: this.props.info.email,
                changeWindowSize: this.props.changeWindowSize,
                heartFn: this.props.heartFn
              }), /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  position: "absolute",
                  top: "47px",
                  left: "0px",
                  right: "0px",
                  height: "281px",
                  marginRight: "20px",
                  marginLeft: "5px"
                }
              }, /*#__PURE__*/_react["default"].createElement(_Events["default"], {
                color: this.props.color,
                token: this.props.token,
                clubUUID: this.props.info.uuid,
                zoom: this.props.info.zoom,
                events: this.props.events,
                timezone: this.props.timezone,
                getClubEvents: this.props.getClubEvents,
                addToCal: this.props.addToCal,
                errorPopup: this.errorPopup,
                authenticator: this.props.authenticator,
                name: this.props.info.name,
                editMailingList: this.props.editMailingList
              })), /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  position: "absolute",
                  top: "338px",
                  left: "0px",
                  right: "0px",
                  height: "435px",
                  marginRight: "20px",
                  marginLeft: "5px"
                }
              }, /*#__PURE__*/_react["default"].createElement(_Photos["default"], {
                info: this.props.info
              })), /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  position: "absolute",
                  top: "768px",
                  left: "0px",
                  right: "0px",
                  height: "195px",
                  marginRight: "20px",
                  marginLeft: "5px"
                }
              }, /*#__PURE__*/_react["default"].createElement(_Stats["default"], {
                info: this.props.info
              })), /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  position: "absolute",
                  top: "960px",
                  left: "0px",
                  right: "0px",
                  height: "211px",
                  marginRight: "20px",
                  marginLeft: "5px"
                }
              }, /*#__PURE__*/_react["default"].createElement(_Reasons["default"], {
                reasons: this.props.info.keyReasons,
                color: this.props.color
              })), /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  position: "absolute",
                  top: "1166px",
                  left: "0px",
                  right: "0px",
                  height: "243px",
                  marginRight: "20px",
                  marginLeft: "5px"
                }
              }, /*#__PURE__*/_react["default"].createElement(_Memories["default"], {
                question: this.props.info.askedanswered_question,
                clubName: this.props.info.name,
                mems: this.props.info.memories
              })), /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  position: "absolute",
                  top: "1403px",
                  left: "0px",
                  right: "0px",
                  height: "162px",
                  marginRight: "20px",
                  marginLeft: "5px"
                }
              }, /*#__PURE__*/_react["default"].createElement(_Officers["default"], {
                color: this.props.color,
                officers: this.props.info.officers
              })), /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  position: "absolute",
                  top: "1536px",
                  left: "0px",
                  right: "0px",
                  height: "121px",
                  marginRight: "20px",
                  marginLeft: "5px"
                }
              }, /*#__PURE__*/_react["default"].createElement(_Social["default"], {
                info: this.props.info
              })), /*#__PURE__*/_react["default"].createElement("div", {
                style: {
                  position: "absolute",
                  top: "1652px",
                  left: "0px",
                  right: "0px",
                  height: "221px",
                  marginRight: "20px",
                  marginLeft: "5px",
                  marginBottom: "20px"
                }
              }, /*#__PURE__*/_react["default"].createElement(_Subscribe["default"], {
                email: this.props.email,
                token: this.props.token,
                clubUUID: this.props.info.uuid,
                mailingList: this.props.info.mailingList,
                editMailingList: this.props.editMailingList
              }))), this.state.errorPopup ? /*#__PURE__*/_react["default"].createElement(_ErrorPopup["default"], {
                title: "No Meeting Link",
                message: "This club has not provided a meeting link for this event",
                closePopup: this.errorPopup,
                mobile: true
              }) : /*#__PURE__*/_react["default"].createElement("div", null));
            } else {}
    }
  }]);

  return ClubPage;
}(_react["default"].Component);

var _default = ClubPage;
exports["default"] = _default;

//# sourceMappingURL=index.js.map